import React from 'react';

export interface BlockRendererProps {
  block: { settings: Record<string, any> };
  config: {
    anaRenk: string;
    aksanRenk: string;
    font: string;
    fontBoyutu: number;
    odemeKosullari?: string;
    gecerlilikNotu?: string;
    altBilgiNotu?: string;
  };
  offer?: any;
  offerType?: 'given' | 'received';
  companyInfo?: any;
}

const FooterBlockRenderer: React.FC<BlockRendererProps> = ({ block, config, companyInfo }) => {
  const s = block?.settings ?? {};
  const showMersis = s.showMersis !== false;
  const showTradeRegistry = s.showTradeRegistry !== false;
  const showContact = s.showContact !== false;

  const name = companyInfo?.name != null ? String(companyInfo.name) : '';
  const address = companyInfo?.address != null ? String(companyInfo.address) : '';
  const phone = companyInfo?.phone != null ? String(companyInfo.phone) : '';
  const email = companyInfo?.email != null ? String(companyInfo.email) : '';
  const mersisNo = companyInfo?.mersisNo != null ? String(companyInfo.mersisNo) : '';
  const tradeRegistryNo = companyInfo?.tradeRegistryNo != null ? String(companyInfo.tradeRegistryNo) : '';
  const altBilgi = config.altBilgiNotu != null ? String(config.altBilgiNotu).trim() : '';

  const fs = `${Math.max(config.fontBoyutu - 2, 9)}px`;

  const line = (content: string): React.ReactNode =>
    content ? (
      <div style={{ marginTop: '4px', lineHeight: 1.45 }}>{content}</div>
    ) : null;

  return (
    <div
      style={{
        marginTop: '20px',
        paddingTop: '14px',
        borderTop: `3px solid ${config.anaRenk}`,
        fontFamily: `'${config.font}', Arial, sans-serif`,
        fontSize: fs,
        color: '#555',
      }}
    >
      {name ? <div style={{ fontWeight: 700, color: '#333', fontSize: `${config.fontBoyutu - 1}px` }}>{name}</div> : null}
      {line(address)}
      {showContact ? (
        <>
          {phone ? line(`Tel: ${phone}`) : null}
          {email ? line(`E-posta: ${email}`) : null}
        </>
      ) : null}
      {showMersis && mersisNo ? line(`MERSİS: ${mersisNo}`) : null}
      {showTradeRegistry && tradeRegistryNo ? line(`Ticaret Sicil No: ${tradeRegistryNo}`) : null}
      {altBilgi ? (
        <div style={{ marginTop: '12px', fontStyle: 'italic', color: '#666', whiteSpace: 'pre-wrap' }}>{altBilgi}</div>
      ) : null}
    </div>
  );
};

export default FooterBlockRenderer;
